import { Table } from 'antd'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const StyledTableSqare = styled(Table)`
  padding: ${props => (props.padding ? props.padding : '0px')};
  width: ${props => (props.width ? props.width : '100%')};
  .score_filter_table .ant-table-tbody .ant-table-cell {
    padding: 0;
  }
  .ant-table-thead {
    height: 65px;
  }
  .ant-table-cell {
    border: 1px solid rgba(127, 127, 127, 0.25);
    padding: ${props => (props.cellSpacing ? props.cellSpacing : '8px')};
    height: 70px;
  }

  .ant-table-content {
    overflow: auto hidden;
    ::-webkit-scrollbar {
      height: 8px;
    }
    ::-webkit-scrollbar-thumb {
      background: #999;
      border-radius: 50px;
    }
  }

  .ant-table-thead > tr:first-child > th.selected-row {
    background: #3249d7;
    color: #ffffff;
  }
  .ant-table-thead > tr:last-child > th.selected-row {
    background: #3249d7;
    color: #ffffff;
    padding: 30px !important;
  }
  .ant-table-cell.selected-row {
    color: #ffffff;
    background: #3249d7;
    border-top: 0.5px solid white;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: ${props => (props.removeHoverEffect ? 'unset' : '')};
  }
  .ant-table-tbody > tr.ant-table-row:hover > td.selected-row {
    background: #3249d7;
  }
  .candidate-list-cell {
    padding: 30px !important;
    text-align: center;
    cursor: pointer;
  }
  td.candidate-list-cell {
    color: rgba(50, 73, 215, 1);
  }

  thead tr .Eligible-students {
    border-top: 2px solid rgba(50, 73, 215, 1) !important;
    border-left: 2px solid rgba(50, 73, 215, 1) !important;
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
    font-size: 11px;
  }
  thead tr .Restricted-Students {
    border-top: 2px solid rgba(50, 73, 215, 1) !important;
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
    font-size: 11px;
  }
  thead tr .Ineligible-students {
    border-top: 2px solid rgba(50, 73, 215, 1) !important;
    border-right: 2px solid rgba(50, 73, 215, 1) !important;
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
    font-size: 11px;
  }

  thead tr .Applied-Students {
    border-top: 2px solid rgba(50, 73, 215, 1) !important;
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
    font-size: 11px;
  }

  thead tr .Not-Applied-students {
    border-top: 2px solid rgba(50, 73, 215, 1) !important;
    border-right: 2px solid rgba(50, 73, 215, 1) !important;
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
    font-size: 11px;
  }

  thead tr .Placed-students {
    border-top: 2px solid rgba(50, 73, 215, 1) !important;
    border-right: 2px solid rgba(50, 73, 215, 1) !important;
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
    font-size: 11px;
  }

  tbody .Eligible-students {
    border-left: 2px solid rgba(50, 73, 215, 1) !important;
  }
  tbody .Ineligible-students {
    border-right: 2px solid rgba(50, 73, 215, 1) !important;
  }

  tbody .Not-Applied-students {
    border-right: 2px solid rgba(50, 73, 215, 1) !important;
  }

  tbody .Placed-students {
    border-right: 2px solid rgba(50, 73, 215, 1) !important;
  }

  tbody tr:last-child td.Eligible-students {
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
  }
  tbody tr:last-child td.Restricted-Students {
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
  }
  tbody tr:last-child td.Ineligible-students {
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
  }

  tbody tr:last-child td.Applied-Students {
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
  }

  tbody tr:last-child td.Not-Applied-students {
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
  }

  tbody tr:last-child td.Placed-students {
    border-bottom: 2px solid rgba(50, 73, 215, 1) !important;
  }

  ${
    '' /* 
  td.ant-table-column-sort {
    border-right: 3px solid rgba(50, 73, 215, 1) !important;
    border-left: 3px solid rgba(50, 73, 215, 1) !important;
  }

  .ant-table-cell.ant-table-column-sort.ant-table-column-has-sorters {
    background-color: rgba(50, 73, 215, 1);
    color: white;
  }
  .last-tr-class td.ant-table-column-sort {
    border-bottom: 3px solid rgba(50, 73, 215, 1) !important;
  }

  tr:last-child td.ant-table-column-sort {
    border-bottom: 3px solid rgba(50, 73, 215, 1) !important;
  } */
  }

  ${
    '' /* td.last-ant-table-current-round {
    border-right: 3px solid rgba(50, 73, 215, 1) !important;
    border-left: 3px solid rgba(50, 73, 215, 1) !important;
  }

  th.last-ant-table-current-round {
    background-color: rgba(50, 73, 215, 1) !important;
    color: white;
  }
  .last-tr-class td.last-ant-table-current-round {
    border-bottom: 3px solid rgba(50, 73, 215, 1) !important;
  }

  tr:last-child td.last-ant-table-current-round {
    border-bottom: 3px solid rgba(50, 73, 215, 1) !important;
  } */
  }



  
 

  border-top-left-radius: 0;
  border-top-right-radius: 0;

  border-top-radius: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  .ant-table-container table > thead > tr:first-child th:first-child,
  .ant-table-container table > tbody > tr td:first-child {
    padding-left: ${props => (props.cellSpacing ? props.cellSpacing : '25px')};
  }
  .ant-table-container table > thead > tr:first-child th:last-child,
  .ant-table-container table > tbody > tr td:last-child {
    padding-right: 25px;
  }
  .ant-table-cell ant-table-selection-column ant-table-cell-fix-left {
    background: #5970e3 !important;
  }
  .ant-table-thead > tr:first-child > th {
    background-color: #f0f0f0;
  }

  ${
    '' /* .ant-table-thead > tr > th {
    background-color: white;
  } */
  }
  .ant-table-column-title {
    width: 90%;
  }
  .ant-table {
    background: #fafafb;
  }
  .ant-table-cell-fix-left ant-table-cell-fix-left-last {
    z-index: 10000 !important;
  }
  tr {
    th {
      background: '#637487' !important;
      font-style: normal;
      font-weight: ${props => (props.fontWeight ? '600' : FONT.FW_500)};
      font-size: ${props => (props.fontSize ? '12px' : FONT.F_XS)};
      line-height: 1.125em;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: ${COLORS.GREY_T_30};

      ::before {
        height: 0px;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    justify-content: center;
  }
  .ant-radio-inner {
    background-color: transparent;
  }

  .ant-table-expanded-row td {
    padding: ${props =>
      props?.expandedRowPadding ? props?.expandedRowPadding : '0'} !important;
  }
  .ant-table-cell-fix-left,
  .ant-table-cell-fix-right {
    background: #fafafb;
  }
`
export const SearchWidth = styled.div`
  width: 80%;
  border-right: 1px solid #dfdfdf;
`
